import React from "react";

const MetaLogo = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M4.2 12c0-3.9 2.5-5.4 4.7-3.4 2.3 2.1 4 6.8 6.3 8.8 2.2 2 4.6.5 4.6-3.4v-2c0-3.9-2.4-5.4-4.6-3.4-2.3 2-4 6.7-6.3 8.8-2.2 2-4.7.5-4.7-3.4z"
      fill="none"
      stroke="#0866FF"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
  </svg>
);

const GoogleAdsLogo = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <line x1="12" y1="5" x2="18.5" y2="16.5" stroke="#4285F4" strokeWidth="5.5" strokeLinecap="round" />
    <line x1="12" y1="5" x2="6.2" y2="15.2" stroke="#FBBC04" strokeWidth="5.5" strokeLinecap="round" />
    <circle cx="6" cy="17.2" r="3" fill="#34A853" />
  </svg>
);

const PlatformLogo = ({ platform, size = 18 }) =>
  platform === "google" ? <GoogleAdsLogo size={size} /> : <MetaLogo size={size} />;

export default PlatformLogo;
